import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators} from '@angular/forms';
import { ContactService } from './../contact.service';
import emailjs, { EmailJSResponseStatus } from 'emailjs-com';
import { environment } from '../../environments/environment.prod';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit {

  FormData: FormGroup;
  sending = false;
  messageSent = false;
  messageResult = "";

  constructor(private builder: FormBuilder,  private contact: ContactService) { }

  ngOnInit() {
    this.FormData = this.builder.group({
      Fullname: new FormControl('', [Validators.required]),
      Email: new FormControl('', [Validators.compose([Validators.required, Validators.email])]),
      Phone: new FormControl(''),
      Comment: new FormControl('', [Validators.required])
    });
  }


  onSubmit(FormData) {
    console.log(FormData)
    // this.contact.PostMessage(FormData)
    //   .subscribe(response => {
    //     location.href = 'https://mailthis.to/confirm'
    //     console.log(response)
    //   }, error => {
    //     console.warn(error.responseText)
    //     console.log({ error })
    //   });

// contact_service
/*
      emailjs.sendForm('jrb_service', 'template_lprgq2q', 'contact-form', 'user_l7K8KUCkZuiYlcBYVq1Mm')
      .then((result: EmailJSResponseStatus) => {
        this.messageSent = true;
        this.messageResult = result.text
      }, (error) => {
        this.messageSent = false;
        this.messageResult = error.text;
      });
*/

      /* 
      emailjs.send("jrb_service","template_lprgq2q",{
        site: "https://localhost:4200",
        from_name: "Adrian Local",
        from_email: "ajvbennett@yahoo.co.uk",
        from_phone: "07919467892",
        message: "test from https://localhost:4200",
      }).then((result: EmailJSResponseStatus) => {
        this.messageSent = true;
        this.messageResult = result.text
      }, (error) => {
        this.messageSent = false;
        this.messageResult = error.text;
      });
*/
      console.log(this.messageResult);
      
  }

  public sendEmail(e: Event) {
    e.preventDefault();
    // emailjs.sendForm('jrb_service', 'template_lprgq2q', e.target as HTMLFormElement, 'user_l7K8KUCkZuiYlcBYVq1Mm')
    //   .then((result: EmailJSResponseStatus) => {
    //     this.messageSent = true;
    //     this.messageResult = result.text
    //   }, (error) => {
    //     this.messageSent = false;
    //     this.messageResult = error.text;
    //   });

    if (this.sending)
      return;

    this.sending = true;

    var emailParams = {
      from_name: this.FormData.value.Fullname,
      from_email: this.FormData.value.Email,
      from_phone: this.FormData.value.Phone,
      message: this.FormData.value.Comment
    };

    // , environment.userId after emailParams
    emailjs.send(environment.serviceId, environment.templateId, emailParams, environment.userId).then((result: EmailJSResponseStatus) => {
      this.messageSent = true;
      this.sending = false;
      this.messageResult = result.text
      this.resetEmail();
    }, (error) => {
      this.messageSent = false;
      this.messageResult = error.text;
      this.sending = false;
    });
  }

  resetEmail() {
    this.FormData.value.Fullname = '';
    this.FormData.value.Email = '';
    this.FormData.value.Phone = '';
    this.FormData.value.Comment = '';
  }
}



